<div class="containerImg">
    <div class="middleBodylogin">
        <div class="middleBody">
            <div class="logoDiv">
                <img alt="Clenli Direct Logo" src="../../../../assets/images/login-logo.png" />
            </div>
            <div class="middleContent forgotpass-page">
                <div class="forgotpass-panel loginForm-rght">
                    <h1>Reset Password?</h1>
                    <h3 *ngIf="!linkGenerated">
                        Enter your Email and instructions will be sent to you!
                    </h3>

                    <div *ngIf="!linkGenerated" class="">
                        <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
                            <div class="form-group">
                                <input type="email" class="form-control" formControlName="email" placeholder="Enter your email" />
                                <div class="ErrorMessageSection">
                                    <p *ngIf="submitted && forgotPasswordForm.get('email')?.hasError('required')">
                                        Please enter your email
                                    </p>
                                    <p *ngIf="submitted && forgotPasswordForm.get('email')?.hasError('email') && !forgotPasswordForm.get('email')?.hasError('required')">
                                        Please enter a correct Email ID
                                    </p>
                                </div>
                            </div>
                            <div class="btn-groups">
                                <button class="btn-addoption" type="button" routerLink="/">
                                    Back
                                </button>
                                <button class="btn-success0 ml-3" type="submit" [disabled]="forgotPasswordForm.pristine">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                    <div *ngIf="linkGenerated" class="sent-reet-link">
                        <div class="form-group">
                            <p class="text-center text-success font-weight-bold">
                                A link has been sent to you to reset your password. Please visit
                                your mail box.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>